import { styled } from '@mui/material';
import { Typography } from 'core/common/ui/ui-kit';

export const AddressWrapper = styled('div')`
  margin-right: auto;
  margin-left: auto;
`;

export const AddressText = styled(Typography)`
  padding-bottom: 8px;
  text-align: center;
  pointer-events: none;
  user-select: none;
`;
